export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11148_READ': 'Read',
    '_11147_UNREAD': 'Unread',
    '_9496_DELETED': 'Deleted',
    '_11151_COMPLETE_ACTION': 'Complete Action'
};
